/*

JSON Loader
--------------------------

Map the JSON tree directly to a D3 tree, without any modifications

*/
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { tryToString } from "./loader-utils";
function convertChildren(node) {
    var e_1, _a;
    var strRep = tryToString(node);
    if (strRep !== undefined) {
        return [
            {
                name: strRep + ":" + typeof node,
                properties: new Map([
                    ["value", strRep],
                    ["type", typeof node],
                ]),
            },
        ];
    }
    else if (typeof node === "object" && !Array.isArray(node) && node !== null) {
        // "Object" nodes
        var children = [];
        var propNames = Object.getOwnPropertyNames(node).sort();
        try {
            for (var propNames_1 = __values(propNames), propNames_1_1 = propNames_1.next(); !propNames_1_1.done; propNames_1_1 = propNames_1.next()) {
                var key = propNames_1_1.value;
                children.push({ name: key, children: convertChildren(node[key]) });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (propNames_1_1 && !propNames_1_1.done && (_a = propNames_1.return)) _a.call(propNames_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return children;
    }
    else if (Array.isArray(node)) {
        // "Array" nodes
        var children = [];
        for (var index = 0; index < node.length; ++index) {
            children.push({
                name: index.toString(),
                children: convertChildren(node[index]),
            });
        }
        return children;
    }
    console.warn("Unhandled JSON type");
    return [{ name: JSON.stringify(node) }];
}
// Load a JSON tree
export function loadJson(json) {
    var root = { name: "root", children: convertChildren(json) };
    return { root: root };
}
// Load a JSON tree from text
export function loadJsonFromText(graphString) {
    var json;
    try {
        json = JSON.parse(graphString);
    }
    catch (err) {
        throw new Error("JSON parse failed with '" + err + "'.");
    }
    return loadJson(json);
}
